(function () {

    'use strict';

    function pxSnmpConfigurations(
        $filter, $location, $ngBootbox, EventServiceEvents, SnmpConfigurationService, SnmpConfigurationsPaging, toastr, URLS, URL_PARAMS, SNMP_FILTERS
    ) {
        return {
            restrict: 'EA',
            scope: {
                me: '='
            },
            templateUrl: 'app/components/settings/snmpConfigurations/snmpConfigurations.template.html',
            link: function (scope) {

                scope.loading = false;
                scope.paging = new SnmpConfigurationsPaging();
                scope.paging.pagingCriteria.embed = ['printers'];
                scope.totalPages = 0;
                scope.orderByColumn = 'NAME';
                scope.reverse = false;
                scope.filters = SNMP_FILTERS;
                scope.networkIds = null;
                scope.networksDialogTitle = null;

                function setSnmpConfigurationOptions(snmpConfigurations) {
                    const isSystemManager = !!scope.me.permissions.TENANT_ADMIN;
                    snmpConfigurations.forEach(snmp => {
                        const isDefault = snmp.info.tenantDefault;
                        const isGlobal = !snmp.info.networkIds || !snmp.info.networkIds.length;
                        const hasPrinters = !!snmp.info._embedded?.printers?.printerCount;
                        snmp.options.isSelectable = !isDefault && (isSystemManager || !isGlobal) && !hasPrinters;
                        snmp.options.isSelected = false;
                    });
                }

                scope.getPrinterCount = function (snmpConfiguration) {
                    return snmpConfiguration.info._embedded?.printers?.printerCount || 0;
                };

                scope.getPageOfSnmpConfigurations = function (page) {
                    if (page !== undefined) {
                        scope.paging.pagingCriteria.page = page;
                    }

                    scope.loading = true;
                    SnmpConfigurationService.getSnmpConfigurationsPaged(scope.paging).then(function (response) {
                        const snmpConfigurations = SnmpConfigurationService.extractSnmpConfigurationsFromResponse(response);
                        setSnmpConfigurationOptions(snmpConfigurations);
                        scope.snmpConfigurations = snmpConfigurations;
                        scope.totalPages = response.data.page.totalPages;
                        scope.checkAllCheckboxes = false;
                        scope.loading = false;
                    }).catch(function(error){
                        scope.loading = false;
                    });
                };

                scope.addSnmpConfiguration = function (event) {
                    event.stopPropagation();

                    let snmpConfiguration = { info: { version: 'V1' } };

                    scope.snmpFormData = {
                        snmpConfiguration: angular.copy(snmpConfiguration),
                        snmpConfigurationOriginal: snmpConfiguration,
                        selectedNetworks: []
                    };

                    scope.addSnmpConfigurationPopupObject = {
                        dimensions: { width: 600 },
                        offset: { top: 20, left: 20 },
                        pointerDirection: null,
                        pointerPosition: 'up',
                        relativePosition: 'left',
                        absoluteX: event.clientX,
                        absoluteY: event.clientY,
                        type: 'SNMP_FORMS',
                        title: 'AddSnmpConfiguration',
                        confirmText: 'Save',
                        cancelText: 'Cancel',
                        clickOutsideToClose: false
                    };
                };

                scope.createSnmpConfiguration = function (snmpConfiguration) {
                    const newSnmpConfiguration = {
                        version: snmpConfiguration.info.version,
                        name: snmpConfiguration.info.name,
                        networkIds: snmpConfiguration.info.networkIds
                    };

                    if (newSnmpConfiguration.version === 'V1') {
                        newSnmpConfiguration.communityName = snmpConfiguration.info.communityName;
                        newSnmpConfiguration.communityNameSet = snmpConfiguration.info.communityNameSet;
                    } else if (newSnmpConfiguration.version === 'V3') {
                        newSnmpConfiguration.user = snmpConfiguration.info.user;
                        newSnmpConfiguration.authenticationLevel = snmpConfiguration.info.authenticationLevel;
                        newSnmpConfiguration.contextName = snmpConfiguration.info.contextName;

                        if (newSnmpConfiguration.authenticationLevel === 'AUTHPRIV') {
                            newSnmpConfiguration.authentication = snmpConfiguration.info.authentication;
                            newSnmpConfiguration.authPhrase = snmpConfiguration.info.authPhrase;
                            newSnmpConfiguration.privacy = snmpConfiguration.info.privacy;
                            newSnmpConfiguration.privacyPhrase = snmpConfiguration.info.privacyPhrase;
                        } else if (newSnmpConfiguration.authenticationLevel === 'AUTHNOPRIV') {
                            newSnmpConfiguration.authentication = snmpConfiguration.info.authentication;
                            newSnmpConfiguration.authPhrase = snmpConfiguration.info.authPhrase;
                        }
                    } else {
                        throw 'Wrong SNMP version!';
                    }

                    scope.creatingSnmpConfiguration = true;
                    SnmpConfigurationService.createSnmpConfiguration(newSnmpConfiguration).then(function (response) {
                        scope.creatingSnmpConfiguration = false;
                    }).catch(function(error){
                        scope.creatingSnmpConfiguration = false;
                    });
                };

                scope.deleteSnmpConfiguration = function (snmpConfiguration) {
                    $ngBootbox.confirm($filter('stringular')($filter('translate')('DeleteSnmpConfiguration'), snmpConfiguration.info.name)).then(function () {
                        snmpConfiguration.deleteSnmpConfig(snmpConfiguration).then(function () {
                            toastr.success($filter('stringular')($filter('translate')('SnmpConfigurationDeleted'), snmpConfiguration.info.name));
                        }).catch(function(error){
                            toastr.error($filter('translate')('Error'));
                        });
                    }).catch(function(error){});
                };

                scope.deleteSelectedSnmpConfigurations = function () {
                    $ngBootbox.confirm($filter('translate')('DeleteAllSelectedSnmpConfigurations')).then(function () {
                        const snmpConfigurationIds = scope.getSelectedSnmpConfigurationIds();
                        SnmpConfigurationService.deleteSnmpConfigurations(snmpConfigurationIds).then(function (results) {
                            const hasSuccessResult = results.some(result => result.success);
                            const hasFailResult = results.some(result => !result.success);
                            if (hasFailResult) {
                                if (hasSuccessResult) {
                                    toastr.warning($filter('translate')('SomeSelectedSnmpConfigurationsDeleted'));
                                } else {
                                    toastr.error($filter('translate')('NoSelectedSnmpConfigurationsDeleted'));
                                }
                            } else {
                                toastr.success($filter('translate')('AllSelectedSnmpConfigurationsDeleted'));
                            }
                        }).catch(function(error){
                            toastr.error($filter('translate')('NoSelectedSnmpConfigurationsDeleted'));
                        });
                    }).catch(function(error){});
                };

                scope.goToSnmpConfigurationProperties = function (snmpConfiguration) {
                    const url = URLS.SNMP_CONFIGURATION_PROPERTIES.replace(URL_PARAMS.SNMP_CONFIG_URL.LOCATION, snmpConfiguration.customProperties.id);
                    $location.path(url);
                };

                scope.getSnmpConfigurationPropertiesUrl = function (snmpConfiguration) {
                    return '/admin/#' + URLS.SNMP_CONFIGURATION_PROPERTIES.replace(URL_PARAMS.SNMP_CONFIG_URL.LOCATION, snmpConfiguration.customProperties.id);
                };

                scope.selectAllItems = function () {
                    scope.snmpConfigurations?.forEach(snmp => {
                        if (snmp.options.isSelectable) {
                            snmp.options.isSelected = scope.checkAllCheckboxes;
                        }
                    });
                };

                scope.selectOneItem = function (snmpConfiguration) {
                    if (snmpConfiguration.options.isSelectable) {
                        if (snmpConfiguration.options.isSelected) {
                            scope.checkAllCheckboxes = scope.snmpConfigurations.every(snmp => !snmp.options.isSelectable || snmp.options.isSelected);
                        } else {
                            scope.checkAllCheckboxes = false;
                        }
                    }
                };

                scope.getSelectedSnmpConfigurationIds = function () {
                    return scope.snmpConfigurations.filter(snmp => snmp.options.isSelected).map(snmp => snmp.customProperties.id);
                };

                scope.isAnySnmpConfigurationSelectable = function () {
                    return scope.snmpConfigurations ? scope.snmpConfigurations.some(snmp => snmp.options.isSelectable) : false;
                };

                scope.isAnySnmpConfigurationSelected = function () {
                    return scope.snmpConfigurations ? scope.snmpConfigurations.some(snmp => snmp.options.isSelected) : false;
                };

                scope.changeOrderByColumn = function (columnName) {
                    if (scope.orderByColumn === columnName) {
                        scope.reverse = !scope.reverse;
                    } else {
                        scope.orderByColumn = columnName;
                        scope.reverse = false;
                    }

                    scope.paging.pagingCriteria.sort = scope.orderByColumn;
                    scope.paging.pagingCriteria.direction = scope.reverse ? 'DESC' : 'ASC';

                    scope.getPageOfSnmpConfigurations();
                };

                scope.showNetworksDialog = function (snmpConfiguration) {
                    scope.networkIds = snmpConfiguration.info.networkIds;
                    scope.networksDialogTitle = snmpConfiguration.info.name;
                };

                scope.hideNetworksDialog = function () {
                    scope.networkIds = null;
                };

                scope.clearPopups = function () {
                    scope.snmpFormData = null;
                    scope.addSnmpConfigurationPopupObject = null;
                };

                scope.openListMenu = function (event, snmpConfiguration) {
                    const position = document.getElementById(event.target.id).getBoundingClientRect();
                    setTimeout(function () {
                        scope.closeListMenu();
                        scope.listMenuContext = snmpConfiguration;
                        scope.listMeta = {
                            position: {
                                left: position.x,
                                top: position.y
                            },
                            parentId: event.target.id,
                            type: 'snmpConfiguration',
                            scrollContainerId: 'SnmpConfigurationsScrollContainer'
                        };
                        scope.$apply();
                    }, 50);
                };

                scope.closeListMenu = function (snmpConfiguration, action) {
                    scope.listMenuContext = null;
                    scope.listMeta = null;

                    switch (action) {
                        case 'GO_TO_SNMP_CONFIGURATION':
                            scope.goToSnmpConfigurationProperties(snmpConfiguration);
                            break;
                        case 'DELETE_SNMP_CONFIGURATION':
                            scope.deleteSnmpConfiguration(snmpConfiguration);
                            break;
                    }
                };

                (function () {
                    setEventListeners();
                    // Don't need to call explicitly as the filter will do it.
                    // scope.getPageOfSnmpConfigurations();
                })();

                function setEventListeners() {
                    scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SNMP_CONFIGURATION_CREATED, function (name, data) {
                        scope.getPageOfSnmpConfigurations();
                    });

                    scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SNMP_CONFIGURATION_UPDATED, function (name, data) {
                        scope.getPageOfSnmpConfigurations();
                    });

                    scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SNMP_CONFIGURATION_DELETED, function (name, data) {
                        scope.getPageOfSnmpConfigurations();
                    });
                }
            }
        };
    }

    pxSnmpConfigurations.$inject = [
        '$filter', '$location', '$ngBootbox', 'EventServiceEvents', 'SnmpConfigurationService', 'SnmpConfigurationsPaging', 'toastr', 'URLS', 'URL_PARAMS', 'SNMP_FILTERS'
    ];

    angular
        .module('printix-admin')
        .directive('pxSnmpConfigurations', pxSnmpConfigurations)
        .constant('SNMP_FILTERS', [
            {
                name: 'Version',
                parameter: 'version',
                type: 'radio',
                values: [
                    {
                        key: 'version',
                        value: 'V1',
                        state: 'V1'
                    },
                    {
                        key: 'version',
                        value: 'V3',
                        state: 'V3'
                    },
                    {
                        key: 'version',
                        value: 'ClearFilter',
                        state: null
                    }
                ]
            },
            {
                name: 'Network',
                parameter: 'networkIds',
                type: 'pagination',
                service: 'NetworkListService',
                paginationObject: null,
                values: []
            },
            {
                name: 'GloballyAvailable',
                parameter: 'global',
                type: 'radio',
                values: [
                    {
                        key: 'global',
                        value: 'Yes',
                        state: true
                    },
                    {
                        key: 'global',
                        value: 'No',
                        state: false
                    },
                    {
                        key: 'global',
                        value: 'ClearFilter',
                        state: null
                    }
                ]
            }
        ]);

})();
